// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnail-image[data-v-26fa7b0e]{width:100%;border-radius:.8rem;aspect-ratio:3/2;pointer-events:none}.thumbnail-wrapper[data-v-26fa7b0e]{position:relative}.thumbnail-wrapper .play-circle[data-v-26fa7b0e]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
